import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// next
import Head from 'next/head';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Page = forwardRef(
  ({ children, title = '', meta, ssr = false, ...other }, ref) => {
    const [render, setRender] = useState(ssr);
    useEffect(() => {
      setRender(true);
    }, []);
    return (
      <>
        <Head>
          <title>{`${title} | Boletia`}</title>
          {meta}
        </Head>

        {render && (
          <Box ref={ref} {...other}>
            {children}
          </Box>
        )}
      </>
    );
  },
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
  ssr: PropTypes.bool,
};

export default Page;
